exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".label-form[data-v-3a64f147]{font-family:San Francisco Display Medium}.rate-component[data-v-3a64f147]{margin:10px 0 20px}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/customers/subComponents/Customer-Details.vue"],"names":[],"mappings":"AACA,6BACE,wCAA4C,CAC7C,AACD,iCACE,kBAAoB,CACrB","file":"Customer-Details.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.label-form[data-v-3a64f147] {\n  font-family: \"San Francisco Display Medium\";\n}\n.rate-component[data-v-3a64f147] {\n  margin: 10px 0 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a64f147","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/sass-resources-loader/lib/loader.js?{"resources":["/opt/build/repo/src/stylesheets/fonts.scss","/opt/build/repo/src/stylesheets/variables.scss","/opt/build/repo/src/stylesheets/mixins.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/clerkinn/customers/subComponents/Customer-Details.vue
// module id = 1394
// module chunks = 2